import { Row, Col, Container, Button, Figure } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Component imports
import TextType from './TextType';
import PixelTransition from './PixelTransition';
import ScrollReveal from './ScrollReveal';
import GlobalNetwork from './GlobalNetwork';
import CountUp from './CountUp';
import ScrollVelocity from './ScrollVelocity';

// Style imports
import './BackgroundCarousel.css';
import './Typed.css';
import './Globe.css';
import './AboutSection.css';

// Images
import AboutImg from '../Img/About/about-new.jpg';

// Shipping Services Images
import SS1 from "../Img/Home/Shipping Services/Project-Bulk-and-ODC-Cargo-Unit.jpg";
import SS2 from "../Img/Home/Shipping Services/Vessel Chartering.png";
import SS3 from "../Img/Home/Shipping Services/Global Freight Forwarding.jpg";
import SS4 from "../Img/Home/Shipping Services/Logistics-and-Warehousing.jpg";
import SS5 from "../Img/Home/Shipping Services/Import.jpg";
import SS6 from "../Img/Home/Shipping Services/Customs-Vat-and-Duty-Management.jpg";
import SS7 from "../Img/Home/Shipping Services/Air-Chartering-and-Freight-Management.jpg";

// Hero Video
import video4 from "../Img/Banner/Video/Logistics Stock Video Of Roadways AirWays Seaways Railways - Cargo_Full-HD.mp4";

function DarkVariantExample() {
  return (
    <>
      {/* ==================== HERO SECTION ==================== */}
      <div className="hero-wrapper">
        <div className="main position-relative">
          <video
            src={video4}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />

          <div className="hero-overlay" />

          <div className="content position-relative">
            <Row className="justify-content-start align-items-center min-vh-100">
              <Col md={7} lg={6}>
                <div className="m-5 hero-text">
                  <div className="typed-text mb-3">
                    <TextType
                      text={["Ocean Freight", "Air Freight", "Complete Logistics Solution"]}
                      typingSpeed={70}
                      pauseDuration={1200}
                      showCursor
                      cursorCharacter="_"
                    />
                  </div>

                  <p className="responsive-para mb-4">
                    MULTI MODAL OVERSEAS PVT LTD (MMOPL) — Complete Logistics Solution.
                    Ocean Freight, Air Freight, Warehousing &amp; Distribution, Custom Clearance,
                    Contract Logistics and Crane Rentals. One partner for your entire supply chain.
                  </p>

                  <div className="d-flex gap-3 flex-wrap">
                    <Button as={Link} to="/Contact" variant="light" size="lg" className='ContactButton'>
                      Contact Us
                    </Button>
                    <Button as={Link} to="/Industries" variant="outline-light" size="lg">
                      Explore Industries
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* ==================== ABOUT US — MODERN ==================== */}
      <section className="about-modern">
        <div className="about-modern__inner">
          {/* Left — content */}
          <div className="about-modern__content">
            <span className="about-modern__eyebrow">About Us</span>

            <h2 className="about-modern__title">
              Logistics Built On <span>Trust, Speed &amp; Precision</span>
            </h2>

            <p className="about-modern__lead">
              <strong>MULTI MODAL OVERSEAS PVT LTD (MMOPL)</strong> is a New Delhi–based integrated
              logistics provider offering end-to-end supply chain solutions across India and worldwide.
              From factory gate to final destination, we handle every stage with reliability, security
              and speed.
            </p>

            <p className="about-modern__lead">
              With deep experience across Automobiles, E-Commerce, Pharmaceuticals, Food, Fashion &amp;
              Retail, Chemicals and Commercial Transport — we deliver tailored solutions that match your
              business objectives and vision.
            </p>

            <div className="about-modern__stats">
              <span className="about-chip"><span className="about-chip__dot" /> 7+ Industries Served</span>
              <span className="about-chip"><span className="about-chip__dot" /> Pan-India Reach</span>
              <span className="about-chip"><span className="about-chip__dot" /> Global Partners</span>
            </div>

            <div className="about-modern__cta">
              <Link to="/About" className="btn-about-primary">
                Learn More
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg>
              </Link>
              <Link to="/Contact" className="btn-about-secondary">
                Get a Quote
              </Link>
            </div>
          </div>

          {/* Right — visual (badge removed) */}
          <div className="about-modern__visual">
            <img src={AboutImg} alt="MMOPL Logistics" />
          </div>
        </div>
      </section>

      {/* ==================== OUR SERVICES ==================== */}
      <Container>
        <h1 className="text-center my-4 text-decoration-underline"><strong>Our Services</strong></h1>

        {/* 1 - Ocean Freight + 2 - Air Freight */}
        <Row className="g-4 justify-content-center my-4">
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Global" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS3} alt="Ocean Freight"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Ocean Freight</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/AirChartering" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS7} alt="Air Freight"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Air Freight</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>
        </Row>

        {/* 3 - Warehousing + 4 - Custom Clearance + 5 - Contract Logistics */}
        <Row className="g-4 justify-content-center my-4">
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Logistics" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS4} alt="Warehousing"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Warehousing &amp; Distribution</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Customs" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS6} alt="Custom Clearance"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Custom Clearance</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Cargo" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS1} alt="Contract Logistics"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Contract Logistics</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>
        </Row>

        {/* 6 - Crane Rentals */}
        <Row className="g-4 justify-content-center my-4">
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Vessel" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={SS2} alt="Crane Rentals"
                    style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p className="fw-bold text-center" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)", color: "#fff" }}>Crane Rentals</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>
        </Row>
      </Container>

      {/* ==================== GLOBAL NETWORK ==================== */}
      <GlobalNetwork />

      {/* ==================== DIRECTOR'S MESSAGE ==================== */}
      <Container fluid className="overflow-hidden bg-dark text-light">
        <Row className="mx-2 my-2 d-flex justify-content-center align-items-center text-center text-md-start">
          <Col xs={12} md={4} className="mb-4 mb-md-0">
            <h2 className="fw-bold mb-3">Our Director's Message</h2>
          </Col>
          <Col xs={12} md={8}>
            <h2 className="fw-bold">Multi Modal Overseas Pvt. Ltd.</h2>
            <h5 className="mb-3">Director</h5>

            <ScrollReveal
              baseOpacity={10}
              enableBlur={true}
              baseRotation={2}
              blurStrength={10}
              className="director-text mt-2"
            >
              At Multi Modal Overseas Pvt. Ltd. (MMOPL), we pride ourselves on being more than a logistics
              provider — we are partners in your success. Our mission is to connect businesses across borders,
              streamline supply chains, and ensure the seamless movement of goods with reliability and precision.
              With an experienced team, a global network of partners and modern infrastructure, we ensure your
              cargo reaches its destination safely, efficiently and on time. Thank you for trusting us with your
              logistics needs.
            </ScrollReveal>
          </Col>
        </Row>
      </Container>

      {/* ==================== COUNT-UP STATS ==================== */}
      <Container fluid className='p-2 img-bg d-flex align-items-center justify-content-center text-center'>
        <Row className='text-light m-4 justify-content-center align-items-center'>
          <Col md={7}>
            <h1 className='justify-text typed-text text-shadow'>Multi Modal Overseas Pvt. Ltd.</h1>
            <p className='justify-text para text-shadow'>
              A trusted integrated logistics company offering complete solutions across Ocean Freight,
              Air Freight, Warehousing &amp; Distribution, Custom Clearance, Contract Logistics and
              Crane Rentals — connecting India to the world.
            </p>
            <div className="text-start">
              <Button
                as={Link}
                to="/Industries"
                variant="outline-light"
                size="lg"
                className='text-shadow'
              >
                Know More
              </Button>
            </div>
          </Col>
          <Col md={5} className="text-end">
            <div>
              <CountUp
                from={0}
                to={3000}
                separator=","
                direction="up"
                duration={1}
                className="count-up-text text-shadow typed-text"
              />
              <p className='fs-3 fw-bold text-shadow'>m<sup>2</sup></p>
              <p className='fs-5 fw-bold text-shadow'>Total Warehouse Area</p>
            </div>
            <div>
              <CountUp
                from={0}
                to={1200}
                separator=","
                direction="up"
                duration={1}
                className="count-up-text text-shadow typed-text"
              />
              <p className='fs-5 fw-bold text-shadow'>Jobs Created</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ==================== SCROLL VELOCITY ==================== */}
      <Container className='py-5 bg-dark text-light' fluid>
        <h1 className='text-center gradient-text1'>Multi Modal Overseas Pvt. Ltd.</h1>
        <ScrollVelocity
          texts={[
            "Ocean Freight | Air Freight | Warehousing & Distribution |",
            "Custom Clearance | Contract Logistics | Crane Rentals |",
            "Complete Logistics Solution | MMOPL |"
          ]}
          velocity={60}
          className="fw-bold fs-2 text-light m-3"
        />
      </Container>

      {/* ==================== TRUST / CLIENTS ==================== */}
      <Container fluid className="gx-0 px-0 overflow-hidden">
        <h1 className='text-center typed-text text-dark'>Companies Who Trust Us</h1>
      </Container>
    </>
  );
}

export default DarkVariantExample;